exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] .ume_U9Wqck0M2NvcYYPW8{padding:8px}.e6Ab_6S42ivAQmr1_Z39Z{font-weight:700}html[dir] .e6Ab_6S42ivAQmr1_Z39Z{padding-bottom:4px}._3KWEiproeM9nd4bzXwYg4k{overflow:hidden;font-size:1px;height:16px}.IrX2lagJOdV_2wQsbWh5M{width:13px;height:13px;display:inline-block;cursor:pointer}html[dir] .IrX2lagJOdV_2wQsbWh5M{border:solid 1px \"[theme:neutralTertiary, default:#a6a6a6]\"}html[dir=ltr] .IrX2lagJOdV_2wQsbWh5M{margin:1px 1px 0 0}html[dir=rtl] .IrX2lagJOdV_2wQsbWh5M{margin:1px 0 0 1px}html[dir] .IrX2lagJOdV_2wQsbWh5M._2lFxGDrIWvawkAmEvXjU4w{border:solid 1px \"[theme:themePrimary, default:#0078D7]\"}._3wkNcdwTNtMQUlMnoOVsZc{cursor:pointer}html[dir] ._3wkNcdwTNtMQUlMnoOVsZc{padding-top:4px}._2r_tUNZ4-GUlCquiFx96JF{width:30px;height:28px}html[dir=ltr] ._2r_tUNZ4-GUlCquiFx96JF{margin-left:20px}html[dir=rtl] ._2r_tUNZ4-GUlCquiFx96JF{margin-right:20px}._3zKBKm8r9wzEi5-3H0qWkI{display:table-row}._9J7je-QCVgSE1cedeeocg{display:table-cell}html[dir] ._9J7je-QCVgSE1cedeeocg{padding-bottom:4px}", ""]);

// exports
exports.locals = {
	"tablePane": "ume_U9Wqck0M2NvcYYPW8",
	"tableTitle": "e6Ab_6S42ivAQmr1_Z39Z",
	"tableRow": "_3KWEiproeM9nd4bzXwYg4k",
	"tableCell": "IrX2lagJOdV_2wQsbWh5M",
	"hovered": "_2lFxGDrIWvawkAmEvXjU4w",
	"customButton": "_3wkNcdwTNtMQUlMnoOVsZc",
	"numInput": "_2r_tUNZ4-GUlCquiFx96JF",
	"insertTableDialogRow": "_3zKBKm8r9wzEi5-3H0qWkI",
	"insertTableDialogCell": "_9J7je-QCVgSE1cedeeocg"
};